import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class AnswerSpot extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,indexnum) {
    super(scene);

    this.indexNum = indexnum;

    this.bg = ABCyaPhaser.Images.addImage(2,2,UIAssetKeys._inside_circle2, this).setOrigin(0);
    this.outline = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._outside_circle2, this).setOrigin(0);
    this.workingWidth = this.outline.width;
    this.workingHeight = this.outline.height;
  }
}